<template>
  <a-form-item>
    <a-range-picker
      class="range-picker"
      v-model:value="valueDate"
      :show-time="{ format: 'HH:mm' }"
      :disabled-date="disabledDate"
      format="DD/MM/YYYY HH:mm"
      valueFormat="YYYY-MM-DD HH:mm:ss"
    >
      <template v-slot:suffixIcon>
        <CalendarOutlined />
      </template>
    </a-range-picker>
  </a-form-item>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import { CalendarOutlined } from "@ant-design/icons-vue";
import { disabledDateFuture, dateToString } from "@/app/shared/utils/dates";

export default defineComponent({
  components: {
    CalendarOutlined,
  },
  setup(_, { emit }) {
    const currentDay = dateToString(new Date()).substring(0, 10);
    const valueDate = ref([`${currentDay} 00:00:00`, `${currentDay} 23:59:59`]);

    watch(valueDate, () => {
      const payload = {
        date_start: dateToString(valueDate.value[0]),
        date_end: dateToString(valueDate.value[1]),
      };
      console.log(payload);
      emit("change", payload);
    });

    return {
      valueDate,
    };
  },
  methods: {
    disabledDate(current) {
      return disabledDateFuture(current);
    },
  },
});
</script>

<style lang="sass" scoped>
.select
  max-width: 180px
  width: 100%

.range-picker
  min-width: 365px
</style>
